const removeOptionality = (depId) => depId.replace(/\?$/, '')

const isOptional = (depId) => depId.endsWith('?')

export const CONTAINER_ID = Symbol.for('container')

export const parseDependencyId = (dependency) => {
  return {
    id: removeOptionality(dependency),
    optional: isOptional(dependency),
  }
}

export const wrapConstant = ({ id, type, value }) => ({
  definition: { id, type, factory: () => value },
})

export const withType =
  (type) =>
  ({ definition, ...rest }) => ({
    ...rest,
    definition: { type, ...definition },
  })
